var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center px-1 pt-md-2 pt-4 px-md-3 mb-3 mt-md-4"},[_c('h2',{staticClass:"heading"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }